import fetch from "@lib/fetch";
import { API } from "../../config";
import { isAuthenticated } from "./auth";

export const createAddress = (address) => {
  return fetch(`${API}/v1/addresses`,{
    mode: 'cors',
    method: "POST",
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${isAuthenticated().token}`
    },
    body: JSON.stringify(address)
  })
  .then(res => {
    return res.json()
  })
  .catch(error => {
    console.log(error);
  })
};

export const getAddresses = () => {
  return fetch(`${API}/v1/addresses`,{
    mode: 'cors',
    method: "GET",
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${isAuthenticated().token}`
    }
  })
  .then(response => {
    return response.json()
  })
  .catch(error => {
    console.log(error);
  })
};

export const updateAddress = (token, addressId, address) => {
  return fetch(`${API}/v1/addresses/${addressId}`,{
    mode: 'cors',
    method: "PUT",
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${isAuthenticated().token}`
    },
    body: JSON.stringify(address)
  })
  .then(response => {
    return response.json()
  })
  .catch(error => {
    console.log(error);
  })
}

export const deleteAddress = (token, addressId) => {
  return fetch(`${API}/v1/addresses/${addressId}`,{
    mode: 'cors',
    method: "DELETE",
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${isAuthenticated().token}`
    }
  })
  .then(response => {
    return response.json()
  })
  .catch(error => {
    console.log(error);
  });
};

export const createAdminAddress = (userId, token, address) => {
  return fetch(`${API}/v1/admin/addresses/users/${userId}`,{
    mode: 'cors',
    method: "POST",
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify(address)
  })
      .then(res => {
        return res.json()
      })
      .catch(error => {
        console.log(error);
      })
};